// Barra de navegación inferior para mobile (.botnav del mockup Datofy V1)
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Link,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import { FiGrid } from "react-icons/fi";
import { NavLink, useLocation } from "react-router-dom";
import { useFilteredRoutes } from "routes.js";
import { CalendarIcon, CreditIcon, HomeIcon, PersonIcon } from "components/Icons/Icons";
import { SidebarBrand, SidebarLinks } from "./SidebarLinks";

const NavItem = ({ to, label, icon: IconComponent, isActive }) => (
  <Link
    as={NavLink}
    to={to}
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    gap="3px"
    flex="1"
    py="6px"
    fontSize="10.5px"
    fontWeight="700"
    color={isActive ? "coral.500" : "ink.400"}
    _hover={{ textDecoration: "none", color: "coral.500" }}
  >
    <IconComponent boxSize="22px" />
    <Text>{label}</Text>
  </Link>
);

const BottomNav = () => {
  const location = useLocation();
  const filteredRoutes = useFilteredRoutes();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const hasRoute = (path) => filteredRoutes.some((r) => r.path === path);

  const items = [
    { to: "/admin/dashboard", label: "Inicio", icon: HomeIcon },
    ...(hasRoute("/usuarios") ? [{ to: "/admin/usuarios", label: "Alumnos", icon: PersonIcon }] : []),
    ...(hasRoute("/agenda") ? [{ to: "/admin/agenda", label: "Agenda", icon: CalendarIcon }] : []),
    ...(hasRoute("/billing") ? [{ to: "/admin/billing", label: "Pagos", icon: CreditIcon }] : []),
  ];

  return (
    <>
      <Flex
        display={{ base: "flex", md: "none" }}
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        h="64px"
        bg="white"
        borderTop="1px solid"
        borderColor="cream.line"
        zIndex="1100"
        align="stretch"
        fontFamily="jakarta"
      >
        {items.map((item) => (
          <NavItem key={item.to} {...item} isActive={location.pathname === item.to} />
        ))}
        <Flex
          as="button"
          onClick={onOpen}
          direction="column"
          align="center"
          justify="center"
          gap="3px"
          flex="1"
          py="6px"
          fontSize="10.5px"
          fontWeight="700"
          color="ink.400"
          _hover={{ color: "coral.500" }}
        >
          <FiGrid size="22px" />
          <Text>Más</Text>
        </Flex>
      </Flex>

      <Drawer isOpen={isOpen} onClose={onClose} placement="bottom">
        <DrawerOverlay />
        <DrawerContent bg="#231E1A" borderTopRadius="20px" maxH="80vh">
          <DrawerCloseButton color="#fff" />
          <DrawerBody px="16px" py="24px" className="thin-scrollbar">
            <SidebarBrand />
            <SidebarLinks routes={filteredRoutes} onNavigate={onClose} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default BottomNav;
